import { Link } from 'react-router-dom';

const quickLinks = [
  { to: '/category/movie', label: '电影专区' },
  { to: '/category/tv', label: '电视剧专区' },
  { to: '/list/hot', label: '热播榜单' },
  { to: '/news', label: '影视资讯' },
  { to: '/about', label: '关于我们' },
];

const genreLinks = [
  { to: '/list/action', label: '动作' },
  { to: '/list/love', label: '爱情' },
  { to: '/list/scifi', label: '科幻' },
  { to: '/list/suspense', label: '悬疑' },
  { to: '/list/comedy', label: '喜剧' },
  { to: '/list/history', label: '古装' },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-background-200 border-t border-background-300/60">
      <div className="px-4 md:px-6 lg:px-10 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50 text-lg">
                <i className="ri-movie-2-fill" />
              </span>
              <span className="text-lg font-bold text-foreground-950 font-heading">红桃影视</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              红桃影视致力于打造专业、易用的在线影视内容与资讯平台，为影视爱好者提供丰富的电影、电视剧资源与及时的行业动态。
            </p>
          </div>

          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">
              <a href="/">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-foreground-600 hover:text-primary-400 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">
              <a href="/category/movie">热门类型</a>
            </h4>
            <ul className="space-y-2.5">
              {genreLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-foreground-600 hover:text-primary-400 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4">
              <a href="/about">联系我们</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-500" />
                support@hongtaotv.demo
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-accent-500" />
                微信公众号：红桃影视
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-500" />
                内容更新：每日 08:00 / 20:00
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="/about"
                aria-label="微博"
                className="w-9 h-9 rounded-full bg-background-300 flex items-center justify-center text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors"
              >
                <i className="ri-weibo-fill" />
              </a>
              <a
                href="/about"
                aria-label="哔哩哔哩"
                className="w-9 h-9 rounded-full bg-background-300 flex items-center justify-center text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors"
              >
                <i className="ri-bilibili-fill" />
              </a>
              <a
                href="/about"
                aria-label="抖音"
                className="w-9 h-9 rounded-full bg-background-300 flex items-center justify-center text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors"
              >
                <i className="ri-tiktok-fill" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© 2026 红桃影视 HongTao TV. 保留所有权利。本站内容均为示范数据，仅用于产品演示。</p>
          <p className="flex items-center gap-4">
            <span className="cursor-pointer hover:text-foreground-800 transition-colors">
              版权声明
            </span>
            <span className="cursor-pointer hover:text-foreground-800 transition-colors">
              使用须知
            </span>
            <span className="cursor-pointer hover:text-foreground-800 transition-colors">
              隐私政策
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}